// If not mobile, show QR code
// If mobile, show iOS/Android 

import React, { useState, useEffect, useRef } from 'react';
import { Link, Redirect, useHistory } from 'react-router-dom';
import userStore from '../../../Stores/User';
import { observer } from 'mobx-react';
import Play from '../../DiscoverNew/Icons/Play.svg';
import Pause from '../../DiscoverNew/Icons/Pause.svg';
import { loadStripe } from '@stripe/stripe-js';
import mixpanel from 'mixpanel-browser';
import loadingIcon from '../../../Assets/loading.gif';
import { createSubscriptionCheckoutSessionWithTrial } from '../../../audiblogsApi';
import queryString from 'query-string';
import qr from './qr.png'
import YoutubeIframe from "../../Landing/Components/YoutubeIframe";
import QRCode from 'qrcode';
import IosInstructions from '../../SetupNew/Components/IosInstructions';
import ShareIconSvg from './share-ios.svg';
import ShortcutsIconPng from './AppleShortcuts.png';
import AndroidIcon from '@mui/icons-material/Android';
import ShareIcon from '@mui/icons-material/Share';
import ShortcutsMac from './ShortcutsMac.png';
import ChromeWebStoreIcon from './Google_Chrome_Web_Store_icon_2015.svg';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import InstallMobileIcon from '@mui/icons-material/InstallMobile';
// import loadingIcon from '../../../Assets/loading.gif';
import { isMobile, isDesktop, isSafari, isChromium, isAndroid, isIOS, isChrome } from 'react-device-detect';
// Import all options from 'react-device-detect' 
import * as DeviceDetect from 'react-device-detect';
// import userStore from '../../../Stores/User';
const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY;
const stripePromise = loadStripe(STRIPE_API_KEY);

const Quickstart2 = observer((props) => {
  const [app, setApp] = useState('');
  const [showCTA, setShowCTA] = useState(false);
  const [quality, setQuality] = useState('Unreal');
  const [sessionId, setSessionId] = useState(null);
  const params = queryString.parse(props.location.search);
  // const app = params.app || '';
  const [qrCode, setQrCode] = useState(null);
  const [nextStep, setNextStep] = useState(null);
  // There are 3 cases:
  // 1. it's mobile & safari -> show apple safari shortcuts & video
  // 2. it's mobile & chrome (and other browsers) -> show apple chrome shortcuts & video
  // 3. it's desktop -> show apple safari shortcuts & mac os video 
  const [video, setVideo] = useState(null);
  const [link, setLink] = useState(null);

  let { userFeedUrl } = userStore;

  const history = useHistory();

  function handleInstall() {
    window.addEventListener('beforeinstallprompt', (event) => {
      event.preventDefault();
      const promptEvent = event;
      // Show the install prompt
      promptEvent.prompt();
      // Wait for the user to respond to the prompt
      promptEvent.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
        } else {
          console.log('User dismissed the install prompt');
        }
      });
    });
  }

  const renderDesktop = () => {
    // If it's desktop, show QR code
    return (
      <>
        <h1 className="headline" style={{ marginBottom: '0px' }}>
          Last Step!
        </h1>
        <div
          className="cta-div"
          style={{ position: 'static', marginTop: '24px' }}
        >
          <button className="cta-button">
            <a
              // href="https://chrome.google.com/webstore/detail/audioread-ultra-realistic/fblchjbbkkaoobkhhbloehgkpdlomido" target='_blank'
              style={{ textDecoration: 'none' }}
              onClick={() => {
                // Open the extension page
                window.open('https://chrome.google.com/webstore/detail/audioread-ultra-realistic/fblchjbbkkaoobkhhbloehgkpdlomido', '_blank');
              }
              }
            >
              Install Browser Extension
            </a>
          </button>
        </div>
      </>
    )
  };

  const RenderMac = () => {
    return (<>
      <h1 className="headline" style={{ marginBottom: '0px' }}>
        How to use Apple Shortcuts
      </h1>
      <video></video>
      <div className="subheadline" style={{ marginTop: '0px' }}>
        Add articles to your podcast while you browse the web.
      </div>
      <div
        className="cta-div"
        style={{ position: 'static', marginTop: '24px' }}
      >
        <button className="cta-button">
          <a
            href="https://www.icloud.com/shortcuts/2e3efdf6e17e42c2a5e48a54b127cce4" target='_blank'
            style={{ textDecoration: 'none' }}
          >
            Add Apple Shortcuts
          </a>
        </button>
      </div>
    </>)
  }

  const RenderApple = () => {

    if (!isMobile && !isSafari) {
      return (<>
        <h1 className="headline" style={{ marginBottom: '0px' }}>
          Install the browser extension
        </h1>
        <h2 className='subheadline'>Convert articles and PDFs in two clicks</h2>

        <div style={{ margin: "5px 0 15px 0" }}>
          <a className="transparent-button mobile" href="https://chrome.google.com/webstore/detail/audiblogs-send-as-podcast/fblchjbbkkaoobkhhbloehgkpdlomido"
            target="_blank"
            style={{
              display: 'flex',
              alignItems: 'center',
              border: "2px solid white",
              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.95)",
            }}>
            <img heig src={ChromeWebStoreIcon} style={{
              width: '40px',
              margin: '10px 15px 10px 10px'
            }}></img>
            <div style={{ textAlign: "left" }}>
              <div>Install Browser Extension</div>
              <div style={{ fontSize: '14px', fontWeight: 'normal', lineHeight: '10px', marginBottom: '6px' }}>via Chrome Web Store</div>
            </div>
          </a>
        </div>
        <div className="cta-div" style={{ position: 'static', marginTop: '24px' }}>
          <button className="cta-button" onClick={() => {
            mixpanel.track("Quickstart: Extension setup done", {
              completed: true
            });
            mixpanel.people.set_once({
              extension_installed: true
            });
            history.push('/onboarding/ChooseVoice');
          }}>
            Finish →
          </button>
          <a 
            href="#" 
            onClick={(e) => {
              e.preventDefault();
              mixpanel.track("Quickstart: Extension setup done", {
                completed: false
              });
              mixpanel.people.set_once({
                extension_installed: false
              });
              history.push('/onboarding/ChooseVoice');
            }} 
            className="sub-cta-link" 
            style={{ fontSize: '16px' }}
          >
            I'll do this later
          </a>
        </div>
      </>)
    }
    return (<>
      <h1 className="headline" style={{ marginBottom: '0px' }}>
        Convert a web page using Shortcuts
      </h1>
      <h2 className='subheadline'>First, tap the button to add the Shortcut
      </h2>
      {/* {video} <br></br> */}
      {/* {link} */}
      {/* <video></video> */}
      <div style={{ margin: "5px 0 15px 0" }}>
        <a className="transparent-button mobile" href={DeviceDetect.isSafari ? "https://www.icloud.com/shortcuts/26b33804580b4fa6afe5abad0e282160" : "https://www.icloud.com/shortcuts/e194f7cd74e34a24b87854bde557eeda"} target='_blank'
          style={{
            display: 'flex',
            alignItems: 'center',
            border: "2px solid rgb(213, 90, 130)",
            boxShadow: "0px 4px ¢4px rgba(0, 0, 0, 0.95)",

          }}>
          <img heig src={ShortcutsIconPng} style={{
            width: '30px',
            margin: '5px'
          }}></img>

          Add Apple Shortcut</a>
      </div>

      {
        DeviceDetect.isMobileSafari ?
          <>
            <div style={{ margin: "2px", display: "flex", alignItems: 'center', justifyContent:'center'  }}>1. Then, tap Share <img src={ShareIconSvg} style={{ margin: "2px" }}></img></div>
            <div style={{ margin: "2px" }}>2. Scroll to the bottom and tap <span style={{ color: '#007AFF' }}>Edit Actions...</span></div>
            <div style={{ margin: "2px" }}>3. Scroll down and tap <span style={{
              backgroundColor: '#248a3d',
              borderRadius: '100%',
              width: '30px',
              height: '30px',
              display: 'inline-block',
              fontSize: '23px',
              margin: '2px'
            }}>+</span> next to Send to Audioread</div>
            <h2 className='subheadline'><i>Browse an article, tap Share, then "Send to Audioread"</i></h2>

            {/* <h2 className='subheadline' style={{ marginTop: '25px' }}>The Shortcut works on MacOS Safari, too</h2>
            <video
              autoPlay
              playsInline
              loop={true}
              muted
              poster={'https://audiblogs-conversions-new.s3.us-east-1.amazonaws.com/images/demo-sequence/desktop-1-540p-safari.jpg'}
              type="video/mp4"
              style={{ maxWidth: "100%" }}
              src={"https://audiblogs-conversions-new.s3.us-east-1.amazonaws.com/images/demo-sequence/desktop-1-540p-safari.mp4"}></video> */}
          </>
          
          : DeviceDetect.isSafari ?
          <div style={{ maxWidth: "800px" }}>
            <video
              autoPlay
              playsInline
              loop={true}
              muted
              poster={'https://audiblogs-conversions-new.s3.us-east-1.amazonaws.com/images/demo-sequence/desktop-1-540p-safari.jpg'}
              type="video/mp4"
              style={{ maxWidth: "500px" }}
              src={"https://audiblogs-conversions-new.s3.us-east-1.amazonaws.com/images/demo-sequence/desktop-1-540p-safari.mp4"}></video>
            {/* <p><i>Browse an article, click Shortcuts in the upper right corner, then "Send to Audioread" to convert it to audio.</i></p> */}
            <h2 className='subheadline' style={{ marginTop: '25px' }}>The Shortcut works on iOS Safari, too</h2>

            <div style={{ margin: "2px", display: "flex", alignItems: 'center', justifyContent: 'center', textAlign:'center' }}>1. On iOS Safari, tap Share <span> <img src={ShareIconSvg} style={{ margin: "2px" }}></img></span></div>
            <div style={{ margin: "2px" }}>2. Scroll to the bottom and tap <span style={{ color: '#007AFF' }}>Edit Actions...</span></div>
            <div style={{ margin: "2px" }}>3. Scroll down and tap <span style={{
              backgroundColor: '#248a3d',
              borderRadius: '100%',
              width: '30px',
              height: '30px',
              display: 'inline-block',
              fontSize: '23px',
              margin: '2px'
            }}>+</span> next to Send to Audioread</div>
            <div><i>After that, find an article, tap Share, then "Send to Audioread" </i></div>


          </div>
          : <div>
            
            <div style={{ margin: "2px", display: "flex", alignItems: 'center', justifyContent:'center' }}>1. Then, tap Share <img src={ShareIconSvg} style={{ margin: "2px" }}></img></div>
            <div style={{ margin: "2px" }}>2. Scroll to the bottom and tap <span style={{ color: '#007AFF' }}>Edit Actions...</span></div>
            <div style={{ margin: "2px" }}>3. Scroll down and tap <span style={{
              backgroundColor: '#248a3d',
              borderRadius: '100%',
              width: '30px',
              height: '30px',
              display: 'inline-block',
              fontSize: '23px',
              margin: '2px'
            }}>+</span> next to Send to Audioread</div>
            <h2 className='subheadline'><i>Browse an article, tap Share, then "Send to Audioread"</i></h2>

          </div>

      }

      <div className="cta-div" style={{ position: 'static', marginTop: '24px' }}>
        <button className="cta-button" onClick={() => history.push('/onboarding/ChooseVoice')}>
          Finish →
        </button>
      </div>

    </>)

  }

  const RenderAndroid = () => {
    return (<>
      <h1 className="headline" style={{ marginBottom: '0px' }}>
        Clip an article using the Android App
      </h1>
      <h2 className='subheadline' style={{display:'flex'}}>Tap <MoreVertIcon /> {`and `} <InstallMobileIcon /><b> Install App</b></h2>
      {/* <div style={{ margin: "5px 0 15px 0" }}>
        <a className="transparent-button mobile"
          onClick={handleInstall}
          style={{
            display: 'flex',
            alignItems: 'center',
            border: "2px solid #3DDC84",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.95)",
          }}>
          <AndroidIcon
            style={{ color: '#3DDC84' }}
          />
          Install Android App</a>
      </div> */}

      <div style={{ margin: "2px", display: "flex", alignItems: 'center' }}>1. After installation, find an article.</div>
      <div style={{ margin: "2px", display: "flex", alignItems: 'center' }}>2. Tap Share <ShareIcon style={{ margin: '2px' }} /> and "More"</div>
      <div style={{ margin: "2px" }}>3. Tap Audioread to convert</div>
      {/* <div
        className="cta-div"
        style={{ position: 'static', marginTop: '24px' }}
      >
        <button className="cta-button">
          <Link to='/add' style={{ textDecoration: 'none' }}>Finish →</Link>

        </button>
      </div> */}

      <div className="cta-div" style={{ position: 'static', marginTop: '24px' }}>
        <button className="cta-button" onClick={() => history.push('/onboarding/ChooseVoice')}>
          Finish →
        </button>
      </div>
    </>)

    return (<>


      <h1 className="headline" style={{ marginBottom: '0px' }}>
        How to Use Android App
      </h1>
      {/* <video></video> */}
      <>
        <div>1. After installation, find a web article</div>
        <div>2. Tap the 3-dot button and "Share"</div>
        <div>3. Scroll, tap "More," and tap "Audioread"</div>
      </>
      <div
        className="cta-div"
        style={{ position: 'static', marginTop: '24px' }}
      >
        <button className="cta-button" onClick={handleInstall}> Install Android App</button>
      </div>
    </>)
  }

  useEffect(() => {
    if (isMobile && isSafari) {
      // Show apple safari shortcuts & video
      setVideo("Mobile Safari Demo Video")
      setLink("Safari: https://www.icloud.com/shortcuts/6a008389e3d74a48ad2b0d4e3b3c98ff")
    } else if (isMobile) {
      // Show apple chrome shortcuts & video
      setVideo("Mobile Chrome Demo Video")
      setLink("Chrome: https://www.icloud.com/shortcuts/b384cebd41854de4828e4c5bf2682ad0")
    } else {
      // Show apple safari shortcuts & mac os video
      setVideo("Mac OS Demo Video")
      setLink("Mac OS: https://www.icloud.com/shortcuts/2e3efdf6e17e42c2a5e48a54b127cce4")
    }

  }, []);

  return (
    <div className="center-static">
      {/* isIOS: {DeviceDetect.isIOS ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
      isDesktop: {DeviceDetect.isDesktop ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
      isAndroid: {DeviceDetect.isAndroid ? <span style={{ color: "green" }}>true</span> : "false"}
      <br></br>
      isChrome: {DeviceDetect.isChrome ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
      isSafari: {DeviceDetect.isSafari ? <span style={{ color: "green" }}>true</span> : "false"}<br></br>
      isMobileSafari: {DeviceDetect.isMobileSafari ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
      isMacOs: {DeviceDetect.isMacOs ? <span style={{ color: "green" }}>true</span> : "false"} */}
      <IosInstructions app feedUrl={userFeedUrl} />
      {
        DeviceDetect.isAndroid ? RenderAndroid()
          : RenderApple()
      }



      {/* <div>
        isSafari: {DeviceDetect.isSafari ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isEmbedded: {DeviceDetect.isEmbedded ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isMobileSafari: {DeviceDetect.isMobileSafari ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isChromium: {DeviceDetect.isChromium ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isMobile: {DeviceDetect.isMobile ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isMobileOnly: {DeviceDetect.isMobileOnly ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isTablet: {DeviceDetect.isTablet ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isBrowser: {DeviceDetect.isBrowser ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isDesktop: {DeviceDetect.isDesktop ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isDesktop: {isDesktop ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isAndroid: {DeviceDetect.isAndroid ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isWinPhone: {DeviceDetect.isWinPhone ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isIOS: {DeviceDetect.isIOS ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isChrome: {DeviceDetect.isChrome ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isFirefox: {DeviceDetect.isFirefox ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isSafari: {DeviceDetect.isSafari ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isOpera: {DeviceDetect.isOpera ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isIE: {DeviceDetect.isIE ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        osVersion: {DeviceDetect.osVersion} <br></br>
        osName: {DeviceDetect.osName} <br></br>
        fullBrowserVersion: {DeviceDetect.fullBrowserVersion} <br></br>
        browserVersion: {DeviceDetect.browserVersion} <br></br>
        browserName: {DeviceDetect.browserName} <br></br>
        mobileVendor: {DeviceDetect.mobileVendor} <br></br>
        mobileModel: {DeviceDetect.mobileModel} <br></br>
        engineName: {DeviceDetect.engineName} <br></br>
        engineVersion: {DeviceDetect.engineVersion} <br></br>
        getUA: {DeviceDetect.getUA} <br></br>
        isEdge: {DeviceDetect.isEdge ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isYandex: {DeviceDetect.isYandex ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        deviceType: {DeviceDetect.deviceType} <br></br>
        isIOS13: {DeviceDetect.isIOS13 ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isIPad13: {DeviceDetect.isIPad13 ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isIPhone13: {DeviceDetect.isIPhone13 ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isIPod13: {DeviceDetect.isIPod13 ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isElectron: {DeviceDetect.isElectron ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isEdgeChromium: {DeviceDetect.isEdgeChromium ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isLegacyEdge: {DeviceDetect.isLegacyEdge ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isMacOs: {DeviceDetect.isMacOs ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>
        isMIUI: {DeviceDetect.isMIUI ? <span style={{ color: "green" }}>true</span> : "false"} <br></br>


      </div> */}
    </div>
  );
})

export default Quickstart2;
